import { render, staticRenderFns } from "./item-alert.vue?vue&type=template&id=5ffecec6"
import script from "./item-alert.vue?vue&type=script&lang=js"
export * from "./item-alert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports